import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_ROLLOUTS = apiPromiseTypes('get-rollouts', 'post');

export const SET_ROLLOUTS = 'waitrose/rollouts/SET_ROLLOUTS';
